<!-- 日计划管理（历史路径；与全周期发运计划维护原日计划 Tab 一致）。新菜单请使用 /car-storage/daily-management/index → views/car-storage/daily-management/index.vue -->
<template>
  <div class="nx-list-page">
    <avue-crud ref="crud" v-model="form" :option="option" :table-loading="loading" :data="data" :page.sync="page" :search.sync="query" :defaults.sync="defaults" @row-save="rowSave" @row-update="rowUpdate" @row-del="rowDel"
      @search-change="searchChange" @search-reset="searchReset" @refresh-change="refreshChange" :beforeOpen="beforeOpen" @current-change="currentChange" @size-change="sizeChange" @on-load="onLoad" @selection-change="selectionChange">
      <template slot="menuLeft">
        <el-button
          type="primary"
          size="small"
          plain
          icon="el-icon-download"
          :loading="exportLoading"
          @click="handleExport"
        >导出</el-button>
      </template>
      <template #menu="{ size, row, index }">
        <el-button v-if="canShowUnAudit(row)" @click="unAudit(row.id)"
                  text
                  type="text"
                  size="small">
          取消审核
        </el-button>
        <el-button v-if="row.auditFlag == 0" @click="audit(row.id)"
                  text
                  type="text"
                  size="small">
          审核
        </el-button>
      </template>
    </avue-crud>
    <select-contract ref="selectContract" @replace="replace" />
  </div>
</template>
<script>
import crudMixins from "@/mixins/crud-mixins";
import { getList, add, update, remove, getDetail ,audit,unAudit, exportExcel } from "./api";
import { searchTimeConfig, rulesInput } from "@/basic-common/util/common";
import { getSettingDate } from '@/util/date'
import { downloadXls } from '@/util/util'
import SelectContract from "@/views/railway-management/transportplan/components/select-contract.vue";
import validator from "@/util/validate";
import {getSearchTimeConfig} from "../../../basic-common/util/common";

export default {
  name: "car-storage/daily-plan-management",
  mixins: [crudMixins],
  components: {
    SelectContract
  },
  data () {
    const that = this
    return {
      exportLoading: false,
      apiConfig: {},
      defaultParams: {
        "businessType": "3", //必须传且为3 汽车入库
        "planType": "2", // 日计划，与 monthly-plan-management 日计划 Tab 一致
      },
      option: {
        ...this.$store.state.publicOption,
        addBtn: false,
        editBtn:false,
        delBtn:false,
        column: [
          {
            label: '计划号',
            prop: 'planNo',
            minWidth: 165,
            rules: [
              { required: true, message: '请输入计划名称', trigger: 'blur' },
            ],
            maxlength: 32,
            search: true,
          },
          {
            label: '客户',
            prop: 'custNo',
            overHidden: true, // 表格超出隐藏
            type: 'select',
            remote: true,
            dicUrl: '/api/produce/blade-dept/select/distinct/select',
            props: {
              label: 'deptName',
              value: 'id'
            },
            minWidth: 165,
            search: true, // 查询是否显示
          },
           {
            label: '煤种',
            prop: 'cargoName',
            type: 'select',
            remote: true,
             width: 150,
            dicUrl: '/api/produce/vardict/select/distinct/pycode?varName={{key}}',
            props: {
              label: 'varName',
              value: 'varName'
            },
            disabled: true
          },
          {
            label: '计划数量(吨)',
            prop: 'planTotalWeight',
            width: 110,
            maxlength: 12,
            rules: [
              { required: true, trigger: "blur", validator: validator.positiveNum2 }
            ],
          },
          {
            label: '计划车数',
            prop: 'planTruckCount',
            type: 'number',
            min: 0,
            precision: 0,
            width: 110,
          },
          {
            label: '完成量(吨)',
            prop: 'planExecuteWeight',
            addDisplay: false,
            editDisplay: false,
            width: 120,
          },
          {
            label: '完成车数',
            prop: 'completeTruckCount',
            type: 'number',
            min: 0,
            precision: 0,
            addDisplay: false,
            editDisplay: false,
            width: 100,
          },
          {
            label: '计划状态',
            prop: 'planState',
            type: 'select',
            dataType: 'string',
            dicUrl: '/api/blade-system/dict-biz/dictionary?code=planState',
            props: {
              label: 'dictValue',
              value: 'dictKey'
            },
            addDisplay: false,
            editDisplay: false,
            viewDisplay: true,
            width: 100,
          },
          {
            label: '计划开始时间',
            prop: 'intervalStartTime',
            type: 'datetime',
            format: 'yyyy-MM-dd HH:mm:ss',
            valueFormat: 'yyyy-MM-dd HH:mm:ss',
            minWidth: 165,
            pickerOptions: {
              disabledDate (time) {
                const now = new Date();
                const currentMonthStart = new Date(now.getFullYear(), now.getMonth(), 1);
                const nextMonthStart = new Date(now.getFullYear(), now.getMonth() + 1, 1);
                // 禁用非本月日期（包括跨月和未来月份）
                return time < currentMonthStart || time >= nextMonthStart;
              }
            },
            rules: rulesInput(2),
          },
          {
            label: '计划结束时间',
            prop: 'intervalEndTime',
            type: 'datetime',
            format: 'yyyy-MM-dd HH:mm:ss',
            valueFormat: 'yyyy-MM-dd HH:mm:ss',
            minWidth: 165,
            pickerOptions: {
              disabledDate (time) {
                const formData = that.form; // 确保this指向正确
                const startTime = formData.intervalStartTime
                  ? new Date(formData.intervalStartTime).getTime() : 0;
                const now = new Date();
                const currentMonthStart = new Date(now.getFullYear(), now.getMonth(), 1);
                const nextMonthStart = new Date(now.getFullYear(), now.getMonth() + 1, 1);
                // 禁用条件：跨月 || 早于开始时间 || 超过当前月最后时刻
                return (
                  time < currentMonthStart ||
                  time >= nextMonthStart ||
                  (startTime && time.getTime() < startTime)
                );
              }
            },
            rules: rulesInput(2),
          },
          {
            label: '合同名称',
            prop: 'contractName',
            search: true, // 查询是否显示
            overHidden: true, // 表格超出隐藏
            width: 150,
            type: 'input',
            remote: true,
            readonly: true,
            rules: rulesInput(2),
            click: () => {
              const { dialogForm } = this.$refs.crud.$refs
              if (dialogForm.boxVisible) {
                // 传入业务类型
                this.$refs.selectContract.open('2')
              }
            }
          },
          {
            label: '审核状态',
            prop: 'auditFlag',
            type: 'select',
            dataType: 'string',
            dicUrl: '/api/blade-system/dict-biz/dictionary?code=audit_flag',
            props: {
              label: 'dictValue',
              value: 'dictKey'
            },
            search: true,
            addDisplay: false,
            editDisplay: false,
            viewDisplay: false,
            width: 110,
          },
          {
            label: '创建时间',
            prop: 'createTime',
            addDisplay: false,
            editDisplay: false,
            minWidth: 165,
          },
          {
            ...getSearchTimeConfig(),
            paramsKey: ["startTime", "endTime"],
            /** 默认查询近30天（含当天）创建数据 */
            searchValue: [getSettingDate('daySLast30'), getSettingDate('dayE')],
          }]
      },
    }
  },
  created () {
    this.apiConfig = {
      getList,
      add: (row) => add({ ...row, ...this.defaultParams }),
      update: (row) => update({ ...row, ...this.defaultParams }),
      remove,
      getDetail
    }
  },
  methods: {
    canShowUnAudit(row) {
      if (!row || row.auditFlag != 2) return false
      return row.planState != 1 && row.planState != 2
    },
    replace (row) {
      const replaceKey = ['id', 'custNo', 'contractEndTime', 'contractStartTime', 'cargoName', 'cargoNo', 'contractName', 'contractNo']
      replaceKey.forEach(item => {
        if (item != 'id') {
          this.$set(this.form, item, row[item])
        } else {
          this.$set(this.form, 'contractExtId', row['id'])
        }
      });
    },
    audit(id){
      this.$confirm_primary('审核')
        .then(() => {
          return audit(id)
        })
        .then((res) => {
          this.onLoad(this.page)
          this.$message({
            type: 'success',
            message: res.data.msg,
          })
        })
    },
    unAudit(id){
      this.$confirm_primary('取消审核')
        .then(() => {
           return unAudit(id)
        })
        .then((res) => {
          this.onLoad(this.page)
          this.$message({
            type: 'success',
            message: res.data.msg,
          })
        })
    },
    /**
     * 导出当前筛选条件下的列表为 Excel（服务端生成，列与表格一致）。
     */
    async handleExport () {
      const total = this.page.total || 0
      if (total < 1) {
        this.$message.warning('无数据可导出')
        return
      }
      const maxRows = 10000
      if (total > maxRows) {
        this.$message.warning(`当前最多导出 ${maxRows} 条，请缩小筛选范围后重试`)
        return
      }
      this.exportLoading = true
      try {
        const params = this.formatParams(Object.assign({}, this.defaultParams, this.query))
        const res = await exportExcel(params)
        downloadXls(res.data, `汽运入库日计划_${Date.now()}.xlsx`)
        this.$message.success('导出成功')
      } catch (e) {
        console.warn(e)
        this.$message.error((e && e.message) || '导出失败')
      } finally {
        this.exportLoading = false
      }
    }
  }
}
</script>
<style scoped lang="scss">
</style>
